import React from "react";
import {graphql} from 'gatsby';
import PropTypes from 'prop-types'

import SEO from "../components/seo";
import Layout from "../components/layout";
import ContactDirectory from "../components/contact-directory";
import Corrections from "../components/corrections";

const ContactDirectoryPage = ({data}) => (
  <Layout>
    <SEO title="Contact Directory" />
    <ContactDirectory contacts={data.contacts.edges.map(edge => edge.node)}/>
    <Corrections/>
  </Layout>
);

ContactDirectoryPage.propTypes = {
  data: PropTypes.object
}

export default ContactDirectoryPage;

export const pageQuery = graphql`
  query {
    contacts: allContactsJson(sort: { order: ASC fields: [last_name] }) {
      edges {
        node {
          id
          first_name
          last_name
          affiliation
          lao_designator
          title
          cpctnet_role
          address1
          address2
          city
          state
          zip
          admin_assistant_last_name
          admin_assistant_first_name
          admin_assistant_email
          email
          phone
          type
        }
      }
    }
  }
`;

